import type { WindowDescriptor } from '@krp/client-runtime'

import type { OneCUiState } from '../../state'

/** Окно «Смены 1С» (раздел «Смены»): кассовые смены одной базы. `:rid` в адресе — смены двух баз не смешиваются. */
export const ONEC_SHIFT_WINDOWS = {
  shifts: 'onec.shifts',
} as const

export const shiftsWindows: readonly WindowDescriptor<OneCUiState>[] = [
  {
    kind: ONEC_SHIFT_WINDOWS.shifts,
    scope: 'resource',
    paths: ['/onec/:rid/shifts'],
    label: 'Смены 1С',
  },
]
